// Order1.js
import React, { useState, useEffect, useRef } from 'react';
import './Order1.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndianRupeeSign, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const defaultItems = [
    {
        "name": "బియ్యం",
        "unit": "Kg",
        "category": "కిరాణా వస్తువులు",
        "image": "https://img500.exportersindia.com/product_images/bc-500/dir_181/5428832/rice-bags-1515756843-3576043.jpeg",
        "variants": [
            { "size": "1Kg", "rate": 50 },
            { "size": "5Kg", "rate": 245 },
            { "size": "10Kg", "rate": 480 }
        ]
    },
    {
        "name": "నువ్వుల నూనె",
        "unit": "Ltr",
        "category": "కిరాణా వస్తువులు",
        "image": "https://img3.exportersindia.com/product_images/bc-small/2022/6/9673359/watermark/iyal-500ml-cold-pressed-sesame-oil-1655704307-6403015.jpeg",
        "variants": [
            { "size": "1L", "rate": 130 },
            { "size": "5L", "rate": 640 }
        ]
    },
    {
        "name": "ఉప్పు",
        "unit": "Kg",
        "category": "కిరాణా వస్తువులు",
        "image": "https://img2.exportersindia.com/product_images/bc-small/dir_181/5419084/tata-salt-1514966381-3557078.jpeg",
        "variants": [
            { "size": "1Kg", "rate": 20 },
            { "size": "5Kg", "rate": 95 }
        ]
    },
    {
        name: "పసుపు పొడి",
        unit: "Kg",
        category: "కిరాణా వస్తువులు",
        image: "https://m.media-amazon.com/images/I/812sgSnc3aL._UF894%2C1000_QL80_.jpg",
        "variants": [
            { size: "100g", rate: 23 },
            { size: "250g", rate: 55 },
            { size: "500g", rate: 110 },
            { size: "1Kg", rate: 222.5 }
        ]
    },
    {
        name: "మిరియాల పొడి",
        unit: "Kg",
        category: "కిరాణా వస్తువులు",
        image: "https://m.media-amazon.com/images/I/81xMTQInyML.jpg",
        "variants": [
            { size: "100g", rate: 45 },
            { size: "250g", rate: 100 },
            { size: "500g", rate: 200 },
            { size: "1Kg", rate: 400 }
        ]
    },
    {
        "name": "తుర్ దాల్",
        "unit": "Kg",
        "category": "కిరాణా వస్తువులు",
        image: "https://ranibrand.com/cdn/shop/files/680901085902RaniToorDal8lbsfront.jpg?v=1698140230",
        "rate": 35
    },
    {
        "name": "Santoor సబ్బు",
        "unit": "Pcs",
        "category": "సబ్బులు",
        image: "https://m.media-amazon.com/images/I/51gzT-GgYUL._UF1000%2C1000_QL80_.jpg",
        "variants": [
            { "size": "75g", "rate": 35 },
            { "size": "125g", "rate": 60 }
        ]
    },
    {
        "name": "Dettol సబ్బు",
        "unit": "Pcs",
        "category": "సబ్బులు",
        image: "https://m.media-amazon.com/images/I/61ccLahWqHL.jpg",
        "variants": [
            { "size": "70g", "rate": 38 },
            { "size": "125g", "rate": 68 }
        ]
    },
    {
        "name": "Lifeboy హ్యాండ్‌వాష్",
        "unit": "Pcs",
        "category": "సబ్బులు",
        image: "https://m.media-amazon.com/images/I/61ndHUqpqfL.jpg",
        "variants": [
            { "size": "200ml", "rate": 45 },
            { "size": "500ml", "rate": 110 }
        ]
    },
    {
        "name": "Clinic Plus షాంపూ",
        "unit": "Pcs",
        "category": "షాంపూలు",
        image: "https://m.media-amazon.com/images/I/515KKnjDcZL._UF1000%2C1000_QL80_.jpg",
        "variants": [
            { "size": "100ml", "rate": 50 },
            { "size": "200ml", "rate": 95 },
            { "size": "400ml", "rate": 180 }
        ]
    },
    {
        "name": "Head & Shoulders షాంపూ",
        "unit": "Pcs",
        "category": "షాంపూలు",
        image: "https://images.ctfassets.net/96bre0uq5ome/6vG4LkdjuCqWrXyQilSmI6/fe87163f7aaef1d31ef4cefc750d2ed4/HeadShoulders_-SH_Charcoal_front.png",
        "variants": [
            { "size": "80ml", "rate": 60 },
            { "size": "180ml", "rate": 110 },
            { "size": "360ml", "rate": 210 }
        ]
    },
    {
        "name": "Himalaya ఫేస్ వాష్",
        "unit": "Pcs",
        "category": "ఫేస్ వాష్ & క్రీములు",
        image: "https://m.media-amazon.com/images/I/81iagtr9c3L._UF1000%2C1000_QL80_.jpg",
        "variants": [
            { "size": "50ml", "rate": 50 },
            { "size": "100ml", "rate": 90 },
            { "size": "150ml", "rate": 130 }
        ]
    },
    {
        "name": "Fair & Lovely క్రీమ్",
        "unit": "Pcs",
        "category": "ఫేస్ వాష్ & క్రీములు",
        image: "https://imageio.forbes.com/specials-images/imageserve/165323482/0x0.jpg?fit=bounds&format=jpg&height=900&width=1600",
        "variants": [
            { "size": "25g", "rate": 30 },
            { "size": "50g", "rate": 65 },
            { "size": "80g", "rate": 100 }
        ]
    },
    {
        "name": "Colgate పేస్ట్",
        "unit": "Pcs",
        "category": "పేస్టులు",
        image: "https://i.ebayimg.com/images/g/epkAAOSw6VxnPziA/s-l1200.jpg",
        "variants": [
            { "size": "50g", "rate": 30 },
            { "size": "100g", "rate": 55 },
            { "size": "150g", "rate": 75 }
        ]
    },
    {
        "name": "Vim లిక్విడ్",
        "unit": "Pcs",
        "category": "డిష్ వాషర్లు",
        image: "https://m.media-amazon.com/images/I/51rhw--KcDL._UF1000%2C1000_QL80_.jpg",
        "variants": [
            { "size": "250ml", "rate": 25 },
            { "size": "500ml", "rate": 50 },
            { "size": "1L", "rate": 95 }
        ]
    },
    {
        "name": "Pril లిక్విడ్",
        "unit": "Pcs",
        "category": "డిష్ వాషర్లు",
        image: "https://m.media-amazon.com/images/I/61t8-gI5R1L.jpg",
        "variants": [
            { "size": "250ml", "rate": 28 },
            { "size": "500ml", "rate": 55 },
            { "size": "1L", "rate": 100 }
        ]
    },
    {
        "name": "Harpic టాయిలెట్ క్లీనర్",
        "unit": "Pcs",
        "category": "టాయిలెట్ క్లీనర్లు",
        image: "https://m.media-amazon.com/images/I/61-jfxZ4VJL.jpg",
        "variants": [
            { "size": "200ml", "rate": 38 },
            { "size": "500ml", "rate": 70 },
            { "size": "1L", "rate": 135 }
        ]
    },
    {
        "name": "Lizol ఫ్లోర్ క్లీనర్",
        "unit": "Pcs",
        "category": "టాయిలెట్ క్లీనర్లు",
        image: "https://i5.walmartimages.com/seo/Lizol-Disinfectant-Surface-Floor-Cleaner-Liquid-Floral-625ml_357827a9-5f35-4ec1-ba08-de303dbffb98.479d03272d6baecdc904a6538a2d39e3.jpeg",
        "variants": [
            { "size": "500ml", "rate": 95 },
            { "size": "1L", "rate": 175 }
        ]
    },
    {
        "name": "Sunlight వాషింగ్ పౌడర్",
        "unit": "Kg",
        "category": "వాషింగ్ పౌడర్లు",
        image: "https://i.ebayimg.com/images/g/nekAAOSwIftgJkjw/s-l1200.jpg",
        "variants": [
            { "size": "500g", "rate": 30 },
            { "size": "1Kg", "rate": 60 },
            { "size": "2Kg", "rate": 115 }
        ]
    },
    {
        "name": "Red Label టీ",
        "unit": "Pcs",
        "category": "టీ పౌడర్లు",
        image: "https://m.media-amazon.com/images/I/41-X8UFzPvL._AC_.jpg",
        "variants": [
            { "size": "100g", "rate": 60 },
            { "size": "250g", "rate": 120 },
            { "size": "500g", "rate": 230 },
            { "size": "1Kg", "rate": 480 }
        ]
    },
    {
        "name": "Taj Mahal టీ",
        "unit": "Pcs",
        "category": "టీ పౌడర్లు",
        image: "https://m.media-amazon.com/images/I/71ICY5RlcZL.jpg",
        "variants": [
            { "size": "250g", "rate": 135 },
            { "size": "500g", "rate": 270 },
            { "size": "1Kg", "rate": 520 }
        ]
    },
    {
        "name": "Good Day బిస్కెట్",
        "unit": "Pcs",
        "category": "బిస్కెట్లు & చిప్స్",
        image: "https://m.media-amazon.com/images/I/61INGvZ3CVL.jpg",
        "variants": [
            { "size": "Small", "rate": 10 },
            { "size": "Large", "rate": 25 }
        ]
    },
    {
        "name": "Lays చిప్స్",
        "unit": "Pcs",
        "category": "బిస్కెట్లు & చిప్స్",
        image: "https://i5.walmartimages.com/seo/Lay-s-Classic-Potato-Chips-Party-Size-13-oz-Bag_066afffd-49e9-4d1c-abb4-3cdce85da3f0.43865a58381c82680d373ec7449460e4.jpeg",
        "variants": [
            { "size": "25g", "rate": 10 },
            { "size": "50g", "rate": 20 },
            { "size": "90g", "rate": 35 }
        ]
    }
];

const rawCategories = [...new Set(defaultItems.map(item => item.category))];
const categories = ["All", ...rawCategories];

export default function Order() {
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [allItems, setAllItems] = useState(() => {
        const saved = localStorage.getItem('savedItems');
        return saved
            ? JSON.parse(saved)
            : defaultItems.map(item => ({
                ...item,
                qty: 0,
                total: 0
            }));
    });
    const [items, setItems] = useState([]);

    const [showQtyModal, setShowQtyModal] = useState(false);
    const [modalItem, setModalItem] = useState(null);
    const [modalQty, setModalQty] = useState('');

    const [showVariantModal, setShowVariantModal] = useState(false);
    const [variantSelectionItem, setVariantSelectionItem] = useState(null);

    const [showCartModal, setShowCartModal] = useState(false); // New state for cart modal
    const [swipedItem, setSwipedItem] = useState(null); // State to track swiped item for deletion

    const [showPopup, setShowPopup] = useState(false);

    // For long press detection
    const longPressTimer = useRef(null);
    const LONG_PRESS_DELAY = 500; // milliseconds

    useEffect(() => {
        localStorage.setItem('savedItems', JSON.stringify(allItems));
    }, [allItems]);

    useEffect(() => {
        const filtered = selectedCategory === "All"
            ? allItems
            : allItems.filter(item => item.category === selectedCategory);
        setItems(filtered);
    }, [selectedCategory, allItems]);

    const handleCategoryChange = (cat) => {
        setSelectedCategory(cat);
    };

    const openQtyModal = (item) => {
        setModalItem(item);
        setModalQty(item.qty > 0 ? item.qty.toString() : '');
        setShowQtyModal(true);
    };

    const confirmQtyChange = () => {
        const newQty = modalQty === '' ? 0 : Math.max(0, parseFloat(modalQty) || 0);

        setAllItems(prevAllItems => {
            let updatedItems = [...prevAllItems];
            const itemIndex = updatedItems.findIndex(item => item.name === modalItem.name);

            if (itemIndex > -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    qty: newQty,
                    total: newQty * updatedItems[itemIndex].rate
                };
            }
            return updatedItems;
        });

        setShowQtyModal(false);
        setModalItem(null);
    };

    // Long press handlers
    const handleMouseDown = (item) => {
        // Clear any existing timer to prevent multiple triggers
        if (longPressTimer.current) {
            clearTimeout(longPressTimer.current);
        }
        longPressTimer.current = setTimeout(() => {
            // Only open quantity modal if the item does NOT have variants
            if (!item.variants) {
                openQtyModal(item);
            }
            longPressTimer.current = null; // Indicate long press has fired
        }, LONG_PRESS_DELAY);
    };

    const handleMouseUp = (item) => {
        if (longPressTimer.current) {
            clearTimeout(longPressTimer.current); // Clear timer if released before long press
            longPressTimer.current = null; // Reset
            // This was a short click, proceed with original handleTileClick logic
            // Only proceed if it was a genuine short click, not if long press already fired
            if (!showQtyModal) { // Check if the quantity modal is not already shown by long press
                handleTileClick(item);
            }
        }
    };

    // New handleTileClick function now called by handleMouseUp if it's a short click
    const handleTileClick = (item) => {
        // If a long press has already opened the modal, do nothing on mouse up
        if (showQtyModal) return;

        if (item.variants) {
            setVariantSelectionItem(item);
            setShowVariantModal(true);
        } else {
            setAllItems(prevAllItems => {
                const updatedItems = [...prevAllItems];
                const itemIndex = updatedItems.findIndex(i => i.name === item.name);

                if (itemIndex > -1) {
                    const currentQty = updatedItems[itemIndex].qty;
                    const newQty = currentQty === 0 ? 1 : currentQty + 1;

                    updatedItems[itemIndex] = {
                        ...updatedItems[itemIndex],
                        qty: newQty,
                        total: newQty * updatedItems[itemIndex].rate
                    };
                }
                return updatedItems;
            });
        }
    };


    const addVariantToCart = (baseItem, variant) => {
        const nameWithVariant = `${baseItem.name} (${variant.size})`;
        setAllItems(prevAllItems => {
            const updatedItems = [...prevAllItems];

            const existingItemIndex = updatedItems.findIndex(item => item.name === nameWithVariant);
            // Find base item in allItems to insert variant right after it if it doesn't exist
            const baseItemIndexInAllItems = updatedItems.findIndex(item => item.name === baseItem.name);

            if (existingItemIndex > -1) {
                updatedItems[existingItemIndex] = {
                    ...updatedItems[existingItemIndex],
                    qty: updatedItems[existingItemIndex].qty + 1,
                    total: (updatedItems[existingItemIndex].qty + 1) * updatedItems[existingItemIndex].rate
                };
            } else {
                const newVariantItem = {
                    name: nameWithVariant,
                    image: baseItem.image,
                    unit: baseItem.unit,
                    category: baseItem.category,
                    rate: variant.rate,
                    qty: 1,
                    total: variant.rate
                };
                if (baseItemIndexInAllItems > -1) {
                    updatedItems.splice(baseItemIndexInAllItems + 1, 0, newVariantItem);
                } else {
                    updatedItems.push(newVariantItem);
                }
            }
            return updatedItems;
        });
        setShowVariantModal(false);
        setVariantSelectionItem(null);
    };
    // Add this to your component state
    const [lastCartCount, setLastCartCount] = useState(0);

    const handleDone = () => {
        // This function will now be triggered by a "Submit" button inside the cart modal

        //     cartItems = allItems.filter(item => item.qty > 0);
        console.log("Cart Items:", cartItems.length > 0 ? cartItems.length : "No items in cart");

        setLastCartCount(cartItems.length); // ✅ Save it BEFORE clearing state
        if (cartItems.length > 0) {
            setAllItems(defaultItems.map(item => ({
                ...item,
                qty: 0,
                total: 0
            })));
            setSelectedCategory("All");
            localStorage.removeItem('savedItems');
            setShowCartModal(false); // Close cart modal
        }

        setShowPopup(true); // Always show popup, even for empty cart
    };


    const closePopup = () => setShowPopup(false);

    const cartItems = allItems.filter(item => item.qty > 0);
    const grandTotal = cartItems.reduce((sum, i) => sum + i.total, 0);
    const totalItemsInCart = cartItems.length;

    const scrollTimeoutRef = useRef(null);
    const [isScrolling, setIsScrolling] = useState(false);

    const handleScroll = () => {
        setIsScrolling(true);
        if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
        scrollTimeoutRef.current = setTimeout(() => {
            setIsScrolling(false);
        }, 150); // 150ms after scroll ends, allow clicks again
    };

    // Swipe to remove functionality
    const handleTouchStart = (e, item) => {
        setSwipedItem(null); // Reset any previously swiped item
        const touch = e.touches[0];
        const startX = touch.clientX;

        const handleTouchMove = (moveEvent) => {
            const currentX = moveEvent.touches[0].clientX;
            const diffX = startX - currentX;

            if (diffX > 50) { // If swiped left enough
                setSwipedItem(item.name);
            } else if (diffX < -50) { // If swiped right enough (to unswipe)
                setSwipedItem(null);
            }
        };

        const handleTouchEnd = () => {
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('touchend', handleTouchEnd);
        };

        document.addEventListener('touchmove', handleTouchMove, { passive: false });
        document.addEventListener('touchend', handleTouchEnd);
    };

    const removeItemFromCart = (itemName) => {
        setAllItems(prevAllItems => {
            const updatedItems = prevAllItems.map(item =>
                item.name === itemName ? { ...item, qty: 0, total: 0 } : item
            );
            return updatedItems;
        });
        setSwipedItem(null); // Reset swiped item after deletion
    };
    const cartItemss = allItems.filter(item => item.qty > 0);

    return (
        <div className="table-wrapper-blue-onlineorder">
            <div className="category-scroll-onlineorder">
                {categories.map((cat, idx) => (
                    <div key={idx}
                        className={`category-title-onlineorder ${selectedCategory === cat ? 'active-onlineorder' : ''}`}
                        onClick={() => handleCategoryChange(cat)}>
                        {cat}
                    </div>
                ))}
            </div>

            <div className="items-grid-onlineorder" onScroll={handleScroll}
                style={{ pointerEvents: isScrolling ? 'none' : 'auto' }}>

                {items.map((item) => (
                    <div key={item.name}
                        className={`item-tile-onlineorder ${item.qty > 0 ? 'selected-item-tile' : ''}`} // <-- Modified line
                        onMouseDown={() => handleMouseDown(item)}
                        onMouseUp={() => handleMouseUp(item)}
                        onTouchStart={() => handleMouseDown(item)} // For mobile touch events
                        onTouchEnd={() => handleMouseUp(item)}     // For mobile touch events
                    >
                        {item.image && (
                            <img src={item.image} alt={item.name} className="product-thumb-tile" />
                        )}
                        <div className="item-name-onlineorder">{item.name}</div>
                        <div className="item-unit-onlineorder">
                            {item.qty > 0 ? (
                                <>
                                    <span>{item.qty} {item.unit}</span> - <FontAwesomeIcon icon={faIndianRupeeSign} /> {(item.total % 1 === 0 ? item.total : item.total.toFixed(2))}
                                </>
                            ) : (
                                <span>{item.unit}</span>
                            )}
                        </div>
                    </div>

                ))}
            </div>

            {/* New View Cart Button */}
            {cartItems.length > 0 && (
                <div className="footer-view-cart-onlineorder">
                    <button className="view-cart-btn-onlineorder" onClick={() => setShowCartModal(true)}>
                        View Cart ({totalItemsInCart})
                    </button>
                </div>
            )}

            {showQtyModal && modalItem && (
                <div className="modal-overlay-onlineorder">
                    <div className="modal-box-onlineorder">
                        <h3>{modalItem.name}</h3>
                        <input type="number" value={modalQty}
                            onChange={e => setModalQty(e.target.value)}
                            className="modal-input-onlineorder"
                            step="any" inputMode="decimal" placeholder="Enter Quantity" />
                        <div className="modal-actions-onlineorder">
                            <button onClick={() => setShowQtyModal(false)}>Cancel</button>
                            <button onClick={confirmQtyChange}>OK</button>
                        </div>
                    </div>
                </div>
            )}

            {showVariantModal && variantSelectionItem && (
                <div className="modal-overlay-onlineorder">
                    <div className="modal-box-onlineorder">
                        <h3>{variantSelectionItem.name} – Select Variant</h3>
                        <ul className="variant-list">
                            {variantSelectionItem.variants.map((v, idx) => (
                                <li key={idx}>
                                    <button onClick={() => addVariantToCart(variantSelectionItem, v)}>
                                        {v.size} – ₹{v.rate}
                                    </button>
                                </li>
                            ))}
                        </ul>
                        <button className='cancel-onlineorder' onClick={() => {
                            setShowVariantModal(false);
                            setVariantSelectionItem(null);
                        }}>Cancel</button>
                    </div>
                </div>
            )}

            {/* Cart Modal */}
            {showCartModal && (
                <div className="cart-modal-overlay-onlineorder">
                    <div className="cart-modal-box-onlineorder">
                        <h3>Cart List</h3>
                        {cartItems.length === 0 ? (
                            <p>Your cart is empty.</p>
                        ) : (
                            <div className="cart-items-container scroll">
                                {cartItems.map((item) => (
                                    <div
                                        key={item.name}
                                        className={`cart-item-swipe-wrapper ${swipedItem === item.name ? 'swiped-onlineorder' : ''}`}
                                        onTouchStart={(e) => handleTouchStart(e, item)}
                                    >
                                        <div className="cart-item-details">

                                            <div className="cart-item-name">{item.name}</div>
                                            <div className="cart-item-qty-rate">
                                                {item.qty} {item.unit} x <FontAwesomeIcon icon={faIndianRupeeSign} /> {item.rate} = <FontAwesomeIcon icon={faIndianRupeeSign} /> {item.total.toFixed(2)}
                                            </div>
                                        </div>
                                        <div className="delete-slide-onlineorder" onClick={() => removeItemFromCart(item.name)}>
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        <div className="cart-modal-footer">
                            <div className="cart-grand-total">
                                <strong>Grand Total:</strong> <FontAwesomeIcon icon={faIndianRupeeSign} /> {grandTotal.toFixed(2)}
                            </div>
                            <div className="cart-modal-actions">
                                <button onClick={() => setShowCartModal(false)}>Close</button>
                                <button onClick={handleDone}>Submit Order</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {showPopup && (
                <div className="modal-overlay-onlineorder">
                    <div className="modal-box-onlineorder success-order">
                        <h3>
                            {lastCartCount > 0
                                ? "మీ ఆర్డర్ విజయవంతంగా నమోదైంది!"
                                : `ఆర్డర్ చేయడానికి ఎటువంటి Products లేవు. (${lastCartCount})`}
                        </h3>


                        <div className="modal-actions-onlineorder">
                            <button onClick={closePopup}>సరే</button>
                        </div>
                    </div>



                </div>
            )}
        </div>
    );
}